/**
 * @Author   qzj
 * 默认参数统一处理
 * @DateTime 2018-04-18
 * @version  [1.0]
 * @param    {[type]}   options._interface [接口名称]
 * @param    {Object}   options.params    [接口参数]
 * @return   {[object]}                     [合并后的请求参数]
 */
const u = navigator.userAgent;
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
import md5 from 'js-md5';
import user from '@/common/user';
let _invokeId = `hjx-xy-store-H5-${md5(
  Math.random()
    .toString(36)
    .substr(2)
)}`; // 生成随机数，方便后台日志查询接口被调方
function getParams({ _interface, params = {} }) {
  const userInfo = user.getUserInfo();
  let { login_token, storeId, channel_user_id, user_name, roleId } = userInfo;
  const resParams = {
    _head: {
      _version: '0.01',
      _msgType: 'request',
      _interface: _interface,
      _remark: '',
      _callerServiceId: 'STOREAPP',
      _groupNo: '123',
      _timestamps: String(new Date().getTime()).substr(0, 10),
      _invokeId,
      _systemType: isAndroid ? 'Android' : isiOS ? 'Ios' : 'none'
    },
    _param: Object.assign(
      {
        system: 'XYAPP-H5',
        login_token,
        userId: channel_user_id,
        userName: user_name,
        storeId,
        storeUserId: '',
        roleId
      },
      params
    )
  };
  return resParams;
}

export default getParams;
